import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import PlaceForm from '../../components/organism/PlaceForm';
import { PlaceTypeEnum } from '../../enums/PlaceTypeEnum';
import { LoginService } from '../../services/LoginService';

type LocationState = { plan?: { placeType: PlaceTypeEnum } | null } | null;

export default function RegisterPlace() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const promotionalCode = searchParams.get('code')?.trim() || '';
  const isPromotionalFlow = promotionalCode.length > 0;

  if (isPromotionalFlow && !LoginService.isAuthenticated()) {
    const redirectUrl = `/promocional?code=${encodeURIComponent(promotionalCode)}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectUrl)}`} replace />;
  }

  const selectedPlan =
    (location.state as LocationState)?.plan ??
    (isPromotionalFlow ? { placeType: PlaceTypeEnum.PARTNER } : null);

  return (
    <PlaceForm
      mode="create"
      selectedPlan={selectedPlan}
      promotionalCode={promotionalCode || undefined}
      bypassPaymentFlow={isPromotionalFlow}
    />
  );
}
